const GRADE_STATUS_LABELS = {
	completed: 'Completed',
	active: 'Active',
}

const formatCompletedDate = iso => {
	if (!iso) return ''
	const date = new Date(iso)
	if (Number.isNaN(date.getTime())) return ''
	return date.toLocaleDateString('en-US', {
		month: 'short',
		day: 'numeric',
	})
}

export default function useCurriculumCardShort({
	card,
	onViewAllSessions,
	onResourceClick,
	onTaskClick,
	onMarkComplete,
}) {
	const { grade, gradeTab, gradeStatus, progress, session } = card
	const isCompleted = session.completed
	const completedDateLabel = formatCompletedDate(session.completedAt)
	const taskLabel =
		session.assignmentButton?.case === 'none' ? 'Create Task' : 'Open Task'

	const handleViewAllSessions = () => onViewAllSessions?.(gradeTab)
	const handleResourceClick = resourceKey =>
		onResourceClick?.(session, resourceKey)
	const handleTaskClick = () => onTaskClick?.(session, grade)
	const handleMarkComplete = () => onMarkComplete?.(session, grade)

	return {
		grade,
		gradeStatus,
		gradeStatusLabel: GRADE_STATUS_LABELS[gradeStatus] || gradeStatus,
		progress,
		session,
		isCompleted,
		completedDateLabel,
		taskLabel,
		handleViewAllSessions,
		handleResourceClick,
		handleTaskClick,
		handleMarkComplete,
	}
}
